// redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { UPDATE_USER_AVATAR, updateUserAvatar } from "~/redux/actions/user";

// views
import { Button } from "antd";
import { LoadingOutlined, FormOutlined } from "@ant-design/icons";

// utils
import { avatarUrl } from "~/utils/app";

const UserAvatarEditor = (props) => {
  let fileInput;

  const setFileInput = (input) => {
    fileInput = input;
  };

  const handleFileChange = (event) => {
    if (event.target.files && event.target.files.length) {
      props.updateUserAvatar(props.token, event.target.files[0]);
    }
  };

  const handleFileChoose = () => {
    if (fileInput) {
      fileInput.click();
    }
  };

  const uploadButton = (
    <Button
      icon={<FormOutlined />}
      type="link"
      onClick={handleFileChoose}
      title="点击上传新头像"
      style={{ color: "#ffffff" }}
    />
  );

  const uploadingSpin = (
    <Button
      type="link"
      icon={<LoadingOutlined />}
      style={{ color: "#ffffff" }}
      disabled
    />
  );

  return (
    <span
      className="ant-avatar ant-avatar-circle user-avatar-editor"
      style={{ backgroundImage: `url(${avatarUrl(props.user, 64)})` }}
    >
      <div className="inner">
        <input
          ref={(fileInput) => setFileInput(fileInput)}
          onChange={handleFileChange}
          className="hidden"
          accept="image/*"
          type="file"
        />
        {props.request[UPDATE_USER_AVATAR] ? uploadingSpin : uploadButton}
      </div>

      <style jsx>
        {`
          .user-avatar-editor {
            width: 48px;
            height: 48px;
            lineheight: 48px;
            backgroundsize: 48px 48px;
            position: relative;
          }

          .inner {
            position: absolute;
            top: 0px;
            bottom: 0;
            left: 0;
            right: 0;
            background: #333;
            opacity: 0.6;
            padding: 2px;
            border-radius: 50%;
          }
        `}
      </style>
    </span>
  );
};

const mapStateToProps = (state) => ({
  request: state.app.request,
  token: state.user.token,
  user: state.user.user,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateUserAvatar,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UserAvatarEditor);
